import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e03796a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landing-content text-center" }
const _hoisted_2 = { class: "landing-title fw-boldest" }
const _hoisted_3 = { class: "landing-subtitle text-gray-600 fs-2" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = { class: "row row-cols-auto align-items-stretch pb-md-10 pb-xxl-20 px-2 px-sm-20 px-md-5 px-xl-20 mx-xl-20 mx-xxl-0 gy-10 gx-5 gx-sm-7 gx-md-7 gy-md-0 gx-lg-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasicCard = _resolveComponent("BasicCard")!
  const _component_n_spin = _resolveComponent("n-spin")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.$t("Find Your Clinical Trial Now")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("We will ask a few questions to find matching clinical trials.")), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("It should only take 5 minutes.")), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("Please select below and tell us who you are.")), 1)
    ]),
    _createVNode(_component_n_spin, {
      show: $setup.isLoading,
      stroke: "#D7D7D9"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.questionnaireTypeList, (questionnaireInfo) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "card-container col-6 col-md-3",
              key: questionnaireInfo.id
            }, [
              _createVNode(_component_BasicCard, {
                class: "h-100",
                id: questionnaireInfo.id,
                title: questionnaireInfo.title,
                description: questionnaireInfo.description,
                "image-src": questionnaireInfo.imageSrc,
                onSelect: $setup.handleQuestionnaireSelect
              }, null, 8, ["id", "title", "description", "image-src", "onSelect"])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}